import { render, staticRenderFns } from "./korektivno-odrzavanje.editor.vue?vue&type=template&id=4d53b71b&scoped=true&"
import script from "./korektivno-odrzavanje.editor.vue?vue&type=script&lang=ts&"
export * from "./korektivno-odrzavanje.editor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d53b71b",
  null
  
)

export default component.exports